import React from 'react';
import { MARKET_SETTINGS, MARKET_SETTINGS_TYPES } from '../../constants';

function MarketSettingsDropdown(props){
  const {
    option,
    dropdownClass,
    dropDown,
    toggleDropDown,
    handleStatus,
    type,
  } = props;

  const selection = type === MARKET_SETTINGS_TYPES.ODDS ? option.oddsDisabled
    : type === MARKET_SETTINGS_TYPES.RESULTS ? option.resultsDisabled : '';
  return (
    <div
      className={`dropdown dropdown--${dropdownClass} ${dropDown === option.id && 'is-open'}`}
      onClick={toggleDropDown.bind(this, option.id)}
    >
      <span>{MARKET_SETTINGS.ODDS[selection]}</span>
      <div className="dropdown__list">
        <div
          className={`dropdown__list-item ${selection === MARKET_SETTINGS.ODDS.ACTIVE ? 'active' : ''}`}
          onClick={handleStatus.bind(this, option.id, MARKET_SETTINGS.ODDS.ACTIVE)}
        >
          Active
        </div>
        <div
          className={`dropdown__list-item ${selection === MARKET_SETTINGS.ODDS.DISABLED ? 'active' : ''}`}
          onClick={handleStatus.bind(this, option.id, MARKET_SETTINGS.ODDS.DISABLED)}
        >
          Disabled
        </div>
      </div>
    </div>
  );
};

export default MarketSettingsDropdown;
